module.exports = __webpack_public_path__ + "img/life-buoy-02.7da65f12.svg";